export enum RIDCContractorStatus {
    SENT = "SENT",
    OPENED = "OPENED",
    W9_BEING_SIGNED = "W9_BEING_SIGNED",
    COMPLETED = "COMPLETED",
    DOCUMENTS_PARTIALLY_UPLOADED = "DOCUMENTS_PARTIALLY_UPLOADED",
    ALL_DOCUMENTS_UPLOADED = "ALL_DOCUMENTS_UPLOADED",
}
